// extracted by mini-css-extract-plugin
module.exports = {"row":"search_row__3pE_1","cell":"search_cell__2ZEE9"};